
import { useState, useEffect } from "react";
import { supabase } from "@/lib/supabase";

export const useAdminRole = () => {
  const [isAdmin, setIsAdmin] = useState(false);

  const checkUserRole = async () => {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) return;

      const { data: hasAdminRole } = await supabase.rpc('has_role', {
        user_id: session.user.id,
        role: 'admin'
      });
      
      setIsAdmin(hasAdminRole);
    } catch (error) {
      console.error('Fejl ved tjek af brugerrolle:', error);
    }
  };

  useEffect(() => {
    checkUserRole();
  }, []);

  return isAdmin;
};
